<div class="payment-options">
  <h3 class="white" i18n="@@setting.notification"><span>Notification options</span></h3>
  <div class="payments-accepted" id="whatsapp-notification-accepted">
    <input class="styled-checkbox large card-payment-option" id="whatsappNotificationAccepted" type="checkbox" [checked]="whatsappNotificationEnabled" (click)="$event.preventDefault()">
    <label for="whatsappNotificationAccepted" i18n="@@whatsApp_notification">Receive WhatsApp Notification</label>
    <div class="switch-wrapper">
      <div class="switch">
        <input type="checkbox" [checked]="!whatsappNotificationEnabled" (change)="updateWhatsappTab($event);false" id="whatsapp-auto-renew" name="whatsapp-auto-renew">
        <span class="slider round"></span>
      </div>
    </div>
  </div>
</div>